import * as React from 'react'
import './styles.scss'

interface Props {
  children: React.ReactNode
}

export function ModalContainer({ children }: Props) {
  return (
    <div className="modal-backdrop">
      <div className="modal-component">{children}</div>
    </div>
  )
}
